import React, { useEffect } from 'react';
import "./ErrorPage.css";
import { Button } from 'antd';
import { Link } from 'react-router-dom';

function ErrorPage() {
    useEffect(() => {
        document.title = "Laundry Buddy - Easter Egg";
        document.querySelector(".loader-container").style.display = "none";
    }, []);

    return (
        <div className='error-page-container'>
            <div className='error-page-head'>
                <h1>404</h1>
                <h1>Oops !</h1>
                <h1>Page Not Found</h1>
                <h6>It looks like the page you were looking for isn't available right now. We're sorry for the inconvenience</h6>
                <Link to="/"><Button>Back To Home</Button></Link>
            </div>
            <div className='error-image-container'>
                <img src={require("../../images/error-page.webp")} alt="" />
            </div>
        </div>
    )
}

export default ErrorPage